
<transition name="slide-fade">
    <vue-draggable-resizable
        v-if              = "visible"
        :w                = "width"
        :h                = "height"
        :y                = "y"
        :x                = "x"
        :resizable        = "false"
        @dragging         = "onDrag"
        :parent           = "true"
        :handles          = "['br']"
        :drag-handle      = "'.drag-handle'"
        class             = "draggable-panel"
        class-name-handle = "draggable-handle-class"
    >
            <div class="drag-handle  v-flex" style="background: #323639">
                <!--
                <div>
                    {{ title }}
                </div>
                -->
                <v-spacer />
                <div style="margin-top: 15px;">
                    <c-toolbar-button
                        icon     = "mdi-close"
                        color    = "white"
                        size     = "24"
                        class    = "mr-2"
                        :tooltip = "$t('common.close')"
                        @click   = "onClose"
                    />
                </div>
            </div>
            <div class="drag-content" :class="border ? 'drag-content-border-on' : 'drag-content-border-off'">
                <slot name = "content" />
            </div>
    </vue-draggable-resizable>
</transition>
